const testimonials = [
  {
    name: '柚子',
    role: '同人读者 · 追更 3 年',
    avatar: 'ri-vip-crown-fill',
    quote: '每天打开今日同人库看今日更新已经成为习惯，哪部汉化更到哪一话清清楚楚，再也没错过过章节。',
  },
  {
    name: '阿树',
    role: '连载追更党',
    avatar: 'ri-leaf-fill',
    quote: '最赞的是连载追踪功能，可以按分类看自己关注的作品进度，新作预告也能第一时间发现，太省心了。',
  },
  {
    name: 'Momo',
    role: '汉化组译者',
    avatar: 'ri-palette-fill',
    quote: '作为译者我也会来这看大家的追更反馈，这里的读者氛围很好，作品热度排行也很有参考价值。',
  },
  {
    name: '小北',
    role: '上班族 · 睡前阅读',
    avatar: 'ri-moon-clear-fill',
    quote: '治愈日常分类简直是宝藏，睡前来一篇刚刚好。页面干净看着舒服，推荐的每一部都很合我胃口。',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100 px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="flex items-center gap-2 text-accent-700 text-sm font-medium">
              <i className="ri-quote-text"></i> VOICES
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">读者怎么说</h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">来自追更同好们的真实口碑</p>
          </div>
          <div className="flex items-center gap-2 text-accent-600">
            <span className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill"></i>
              ))}
            </span>
            <span className="text-sm text-foreground-600">4.9 / 5</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t) => (
            <figure key={t.name} className="bg-background-50 border border-background-200 rounded-lg p-6">
              <i className="ri-double-quotes-l text-3xl text-accent-300"></i>
              <blockquote className="mt-3 text-sm text-foreground-600 leading-relaxed">{t.quote}</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-100 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 text-lg">
                  <i className={t.avatar}></i>
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}